export const IconCv: {
  name: 'icon_cv-509724d50aa4'
} = {
  name: 'icon_cv-509724d50aa4'
}
